module.exports = __webpack_public_path__ + "img/jau.ab85183a.png";